export const ANALYTICAL_MIXING_SELECTED_WAREHOUSE = 'ANALYTICAL_MIXING_SELECTED_WAREHOUSE';